export enum RegistrationScreenEnabledVariant {
  One = 'variant-one',
  Two = 'variant-two',
}
